import { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  query,
  where,
  doc,
  updateDoc
} from "firebase/firestore";
import { db } from "../firebase";

function OutgoingTransferStatus({ car, userId, showToast }) {
  const [request, setRequest] = useState(null);

  useEffect(() => {
    const loadRequest = async () => {
      const snapshot = await getDocs(
        query(
          collection(db, "transferRequests"),
          where("carId", "==", car.id),
          where("fromUserId", "==", userId),
          where("status", "==", "pending")
        )
      );

      if (!snapshot.empty) {
        setRequest({
          id: snapshot.docs[0].id,
          ...snapshot.docs[0].data()
        });
      }
    };

    loadRequest();
  }, [car.id, userId]);

  const cancelTransfer = async () => {
    const confirmed = window.confirm(
      "Cancel this pending transfer request?"
    );

    if (!confirmed) return;

    await updateDoc(doc(db, "transferRequests", request.id), {
      status: "cancelled",
      cancelledAt: new Date().toISOString()
    });

    setRequest(null);
   showToast("Transfer Cancelled", "The transfer request has been cancelled.");
  };

  if (!request) return null;

  return (
    <div style={boxStyle}>
      <strong>Transfer Pending</strong>
      <p>To: @{request.toUsername}</p>

      <button
        onClick={cancelTransfer}
        style={cancelButtonStyle}
      >
        Cancel Transfer
      </button>
    </div>
  );
}

const boxStyle = {
  backgroundColor: "#2a1f1f",
  border: "1px solid #e10600",
  borderRadius: "10px",
  padding: "12px",
  marginTop: "10px"
};

const cancelButtonStyle = {
  backgroundColor: "#333",
  color: "white",
  border: "1px solid #555",
  padding: "8px 10px",
  borderRadius: "8px",
  fontWeight: "bold",
  cursor: "pointer"
};

export default OutgoingTransferStatus;